module.exports = __webpack_public_path__ + "img/product-card-04.f331f6a.webp";